import styled from 'styled-components';

export const ContentPerfilRefundable = styled.div`
  margin: ${({ theme }) => `${theme.spacing.km8} ${theme.spacing.km8} ${theme.spacing.km0} ${theme.spacing.km8}`};

  width: 436px;
  border-radius: ${({ theme }) => theme.spacing.km4};
  padding: ${({ theme }) => theme.spacing.km8};
  gap: ${({ theme }) => theme.spacing.km6};
  background-color: ${({ theme }) => theme.color.background.neutral.weak};

  ul {
    padding: ${({ theme }) => theme.spacing.km4} 0;

    li {
      display: flex;
      align-items: center;
      list-style-type: none;

      p {
        padding-left: ${({ theme }) => theme.spacing.km4};
      }

      &:first-child {
        margin-bottom: ${({ theme }) => theme.spacing.km4};
      }
    }
  }
`;

export const WrapperContentTitleBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`;

export const WrapperSign = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  fuel-sign:last-child {
    margin-left: ${({ theme }) => `-${theme.spacing.km3}`};
  }
`;
